
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as edobgl6uEnFFAu0WRG_Uv5B3bqxWCgjz4ZtUv6KYhOUO0IMeta } from "/var/www/2025-06-09_17_20/pages/edo.vue?macro=true";
import { default as helphX3wsMrkmqvWSwH3J653WUtt02oDomdZkU1rhzxHGlsMeta } from "/var/www/2025-06-09_17_20/pages/help.vue?macro=true";
import { default as cargoNdJPwYZYF7bYGwPo4OrnChluQ4LL8qUeaW6oTnm_mrcMeta } from "/var/www/2025-06-09_17_20/pages/cargo.vue?macro=true";
import { default as chinaZJvJzjZdwhE5nBhx2orXRpkPumo1KZK5yWEvV3TaWFAMeta } from "/var/www/2025-06-09_17_20/pages/china.vue?macro=true";
import { default as indext_45wg6jSXZZfeayPNiG2WVLAJN1Crbw_7REZ1Fo0nrpAMeta } from "/var/www/2025-06-09_17_20/pages/index.vue?macro=true";
import { default as _91slug_93gxTN041b_45LmofYwJFFlKlvfl2iwujsiDFLmwN4rVZKsMeta } from "/var/www/2025-06-09_17_20/pages/[slug].vue?macro=true";
import { default as belarus5SNGNEZEfUyJJ9frkfB9GT1D9sWazR_45KqApTX_xjkgoMeta } from "/var/www/2025-06-09_17_20/pages/belarus.vue?macro=true";
import { default as bonusesPd8ia3nHRpEcpvUaJ9q_45NXFMkHBpQCkejZn30Z3KIrgMeta } from "/var/www/2025-06-09_17_20/pages/bonuses.vue?macro=true";
import { default as apirFub2qQW7ftiiI_45JPFyIhyk27TFqFL9MOsQ8uPRqyZ8Meta } from "/var/www/2025-06-09_17_20/pages/dev/api.vue?macro=true";
import { default as cmsHjNvgX7tQ9HaSGPVLHAfUYK8eGOXJR4zReZ6H2VrFkwMeta } from "/var/www/2025-06-09_17_20/pages/dev/cms.vue?macro=true";
import { default as konkursuTVN5Px3Nj9_ejCRbSa6P5MIqPtN2_iCOyTC5GjPBLgMeta } from "/var/www/2025-06-09_17_20/pages/konkurs.vue?macro=true";
import { default as successlkK4xcRwBjacXZPd5IvEow7skzevYv62QQDaM9BjiWQMeta } from "/var/www/2025-06-09_17_20/pages/success.vue?macro=true";
import { default as tariffs_Ej4yu8AbRmIvj_mqgtzYijiU_3p84lhaQs4uEP2cKcMeta } from "/var/www/2025-06-09_17_20/pages/tariffs.vue?macro=true";
import { default as vacancyngVCmb_czfUzEdW2tzeod_45PHHoqsWsz5_45LwkB9lFisEMeta } from "/var/www/2025-06-09_17_20/pages/vacancy.vue?macro=true";
import { default as contactsKAI1qbkHRYReaMSRcsmkObSeytRy0yJa0GATn_I64ugMeta } from "/var/www/2025-06-09_17_20/pages/contacts.vue?macro=true";
import { default as giveawayhBj4cWGBT_B3ICrspplQPRfkfZ4pJ6BdBTkA0bHsAn8Meta } from "/var/www/2025-06-09_17_20/pages/giveaway.vue?macro=true";
import { default as guide_45lk8J0Ruq9ukSJNbiOFE63Av9b8dfdkNjOHjhRQ1EWKc8gMeta } from "/var/www/2025-06-09_17_20/pages/guide-lk.vue?macro=true";
import { default as servicesGG_45gwN_Sh0ipu1AecirUUYcmi_45CryjbLLDJCi3N_45xPQMeta } from "/var/www/2025-06-09_17_20/pages/services.vue?macro=true";
import { default as telegramg_EoFuiSW343poFLE_45x2OBi8TrLRtOaI0J_iAhDTMBEMeta } from "/var/www/2025-06-09_17_20/pages/telegram.vue?macro=true";
import { default as documents0SMOqETvChItM_45AhWjfsyKOOftFRG2_ijbS_45z5NUJKUMeta } from "/var/www/2025-06-09_17_20/pages/documents.vue?macro=true";
import { default as franchisecfSbdfQmm3KoFHCnZYb8BuNlRxtq14Y_Zc7e8ZVPOn4Meta } from "/var/www/2025-06-09_17_20/pages/franchise.vue?macro=true";
import { default as insurancekjlHokfiLNKUFCvI2Krg8aygsd_45Yat4bq3KURcF53pwMeta } from "/var/www/2025-06-09_17_20/pages/insurance.vue?macro=true";
import { default as kirghizia6SwLQz9Fdo2zsmLzjzaXefZpVG0BNEl48FyhuOTnb6MMeta } from "/var/www/2025-06-09_17_20/pages/kirghizia.vue?macro=true";
import { default as mapSchemeeuuH0MlEB0fN3MxVhnBTK1qgDAxKTdOmN1rFiiwg14sMeta } from "/var/www/2025-06-09_17_20/pages/mapScheme.vue?macro=true";
import { default as _91id_93nTW7bvpipa6_45l6zbwDekUcTLX7bDSW3vgF35okipk4AMeta } from "/var/www/2025-06-09_17_20/pages/news/[id].vue?macro=true";
import { default as return_45sdqPrPFiD_hmhR5Qwvy_45z7LHHvfNDWmpHD5mlVBMXRJ1sMeta } from "/var/www/2025-06-09_17_20/pages/return-sd.vue?macro=true";
import { default as smsClient9R0MxxlZokKgqc9gB4WKM2ciHjLoI7Jj1T9lZ7xI19UMeta } from "/var/www/2025-06-09_17_20/pages/smsClient.vue?macro=true";
import { default as terminalsQ04z2LQDgapGNDQfhsWFAAsLivhrQJE_iiWH8UQ8jUAMeta } from "/var/www/2025-06-09_17_20/pages/terminals.vue?macro=true";
import { default as iframe3ExMzPWCIqFafIr6vbxb_WyGI6WmT52h57FCFzNevTIMeta } from "/var/www/2025-06-09_17_20/pages/dev/iframe.vue?macro=true";
import { default as directionsHdFpcv1lMlyIt6dU3f7CLoQtTWApd7o9E19aZwmW6fEMeta } from "/var/www/2025-06-09_17_20/pages/directions.vue?macro=true";
import { default as kazakhstanYa_45Pg2SAfeqSN0xEKTTv2aZKhJwcbGWxYna_ZD9tbB4Meta } from "/var/www/2025-06-09_17_20/pages/kazakhstan.vue?macro=true";
import { default as indexpIDvkyFQ_45UNnyocl9BHAR_z1rfizRNqxgBCHC0AJBFwMeta } from "/var/www/2025-06-09_17_20/pages/news/index.vue?macro=true";
import { default as svgl44_SbidT1IQFXkAF15JrwQqWKqlyaxnzfXrBvSH7QMMeta } from "/var/www/2025-06-09_17_20/pages/ui-kit/svg.vue?macro=true";
import { default as vzpay_45failtph1OtGhc8Z_45ERMU_45ZZJzrK7QxczC6j_oSMU9R4E0n4Meta } from "/var/www/2025-06-09_17_20/pages/vzpay-fail.vue?macro=true";
import { default as constructorYrGu4RsDdUKp6oMWRw_45y1N4eROrryjZfdzxj4H8DCCoMeta } from "/var/www/2025-06-09_17_20/pages/constructor.vue?macro=true";
import { default as indexSz_45ycf880bbb1BBDRrPV6OdEHioUMWFNrEX0AbtX_UAMeta } from "/var/www/2025-06-09_17_20/pages/gifts/index.vue?macro=true";
import { default as information_7XvAIxKNtEPSv_45EuiZ9lyFVOe1DN4UXWh_45BfH_451AnUMeta } from "/var/www/2025-06-09_17_20/pages/information.vue?macro=true";
import { default as lightapQNKBHYJmsDbIzPdG6oK80PXbFglrvrG7DW79IQQLUMeta } from "/var/www/2025-06-09_17_20/pages/order/light.vue?macro=true";
import { default as claim_45filing8V0y35qMD6MIcg__45kv9_45WCWVNmlld8naVw_45uejj_453VkMeta } from "/var/www/2025-06-09_17_20/pages/claim-filing.vue?macro=true";
import { default as _91type_933ra2SlhHKYupZlImm5zAw6OTDhzwbxcU2hR7_45ZzVrDMMeta } from "/var/www/2025-06-09_17_20/pages/gifts/[type].vue?macro=true";
import { default as marketplacesNMbW2TBnXDZJYGo6GyUp1x5B_45sBnpXQZltC1Y_EnkvYMeta } from "/var/www/2025-06-09_17_20/pages/marketplaces.vue?macro=true";
import { default as networkshopsgu_5rrkY7Kq5Haogaq0ZABwFhDgsXmxs_45Z9FKcdrF_YMeta } from "/var/www/2025-06-09_17_20/pages/networkshops.vue?macro=true";
import { default as online_45storehwszCNWbiOoQZAs6kAHyH9cHdpwPG7YHo6feFkX7NjcMeta } from "/var/www/2025-06-09_17_20/pages/online-store.vue?macro=true";
import { default as manageTXkqjXYZ9jw_45pWCzk1g6yK1SwE0yewXmdTn28z_k0qcMeta } from "/var/www/2025-06-09_17_20/pages/order/manage.vue?macro=true";
import { default as registrationuLYxgcFIgFPqIcMmHax_teHClV3FzbYwX490SUiFhdoMeta } from "/var/www/2025-06-09_17_20/pages/registration.vue?macro=true";
import { default as run_45scheduleJmcQbOQLhDXOukUQUPl38vFAOZy_hlR70XukufBoDlkMeta } from "/var/www/2025-06-09_17_20/pages/run-schedule.vue?macro=true";
import { default as safe_45custody2l6PWB0uwodUJNu7umoIOPX5dYFQcxNrOZOBa1Hj0vUMeta } from "/var/www/2025-06-09_17_20/pages/safe-custody.vue?macro=true";
import { default as image_45YegLUrFLAoCw5AqDHUjKCnmAiMd3JxbdtIvRs4aalsMeta } from "/var/www/2025-06-09_17_20/pages/ui-kit/image.vue?macro=true";
import { default as indexyetH_9aHXR6VTuCfcWaDq1LcJlvs_sDwksr37wHl_XgMeta } from "/var/www/2025-06-09_17_20/pages/ui-kit/index.vue?macro=true";
import { default as bagVhoEnybPA_ObDyrV26wx6V_45w6KGQGtjUzcI7_45kiL_45ycMeta } from "/var/www/2025-06-09_17_20/pages/wrapping/bag.vue?macro=true";
import { default as boxn2MlpUXFDjko_q8RFK20Yhghc8LLDza1FVPw7K51h6oMeta } from "/var/www/2025-06-09_17_20/pages/wrapping/box.vue?macro=true";
import { default as cargo_45loadingaaAdrcExXdjd6CJuE7Yze9TYTUQ_oVA49MRsO6JzXJkMeta } from "/var/www/2025-06-09_17_20/pages/cargo-loading.vue?macro=true";
import { default as happybirthdayEV0gy9GavUUqsHk6F9mCZdIeKqMFPOh5xkC5eD2taucMeta } from "/var/www/2025-06-09_17_20/pages/happybirthday.vue?macro=true";
import { default as manageneaTuz1CqErIwgT2ciUWb2SvWHKcjDwgry19H3jnANoMeta } from "/var/www/2025-06-09_17_20/pages/iframe/manage.vue?macro=true";
import { default as authG2WsOir9TYlYsABpeqCQHBsXZbXXYivCvuNo2aIQnkoMeta } from "/var/www/2025-06-09_17_20/pages/personal/auth.vue?macro=true";
import { default as public93Nyc0Tdc74wxmZd2OvbV4R_45ewG8tRNQ_w8JHlgAeRoMeta } from "/var/www/2025-06-09_17_20/pages/ui-kit/public.vue?macro=true";
import { default as already_45answerjpIspW9mGVl7LAKYRtp9CmLa24jvnnSZEYdLcaS5dIMMeta } from "/var/www/2025-06-09_17_20/pages/already-answer.vue?macro=true";
import { default as tariffshJLOaLrv7Bi7TFxBKTKPlpYWzJTy_Y5oFORsqbvqQkwMeta } from "/var/www/2025-06-09_17_20/pages/iframe/tariffs.vue?macro=true";
import { default as _91id_93_45zqraMmoJZifAhx1CkBTLXK9JaH3efMLUcgJbmjGP58Meta } from "/var/www/2025-06-09_17_20/pages/order/pay/[id].vue?macro=true";
import { default as indexRvE1pXrdGZZYAzUcGGVR3CRKF_45romhywBWB84eqRHr8Meta } from "/var/www/2025-06-09_17_20/pages/personal/index.vue?macro=true";
import { default as privacy_45policyvEGOfvYAb_45MJEMliyPDg0x_45AY5zu7sSqWKJpvy6NOmYMeta } from "/var/www/2025-06-09_17_20/pages/privacy-policy.vue?macro=true";
import { default as _91hash_93Ck6ql8rkxYnUC25LVyLGPra9G_ZCT9pCP4KsHYWfKc4Meta } from "/var/www/2025-06-09_17_20/pages/welcome/[hash].vue?macro=true";
import { default as indexRKkL_KRITqpv5bT0_45ENQF17AqHkuTmZ07v_Fw7U5PxwMeta } from "/var/www/2025-06-09_17_20/pages/wrapping/index.vue?macro=true";
import { default as delivery_45russiarOFHCKdxY7yWPiJZagzAoGzTcldwU_45aoWiu8Am7NmYIMeta } from "/var/www/2025-06-09_17_20/pages/delivery-russia.vue?macro=true";
import { default as payment_45methodsJJjgcremyZnEL9fl_LbZazje_45CCSKDQ8otgeucx0914Meta } from "/var/www/2025-06-09_17_20/pages/payment-methods.vue?macro=true";
import { default as qr_45infoKk8Pv37sdYYjqZx7euoMQsWjESiSgpRjkQal9tadWLkMeta } from "/var/www/2025-06-09_17_20/pages/payment/qr-info.vue?macro=true";
import { default as successUpqhl5ZlxrCEatKrfhqHCUIzOtvsNPzQmPNmzrCY2HcMeta } from "/var/www/2025-06-09_17_20/pages/payment/success.vue?macro=true";
import { default as importTyOaM_45NgqooTYkprjsm6d2t3D5adAKIXgxJ0Dni1kHIMeta } from "/var/www/2025-06-09_17_20/pages/personal/import.vue?macro=true";
import { default as logout8WFmjF89qSSQZfozrtq3mz4mnbxZkBPWiNAt2alFTngMeta } from "/var/www/2025-06-09_17_20/pages/personal/logout.vue?macro=true";
import { default as address_45deliverys1N87Habm0yPLaqMkLj2dQMS82oUmneKrHjiA0FvmW8Meta } from "/var/www/2025-06-09_17_20/pages/address-delivery.vue?macro=true";
import { default as cash_45on_45deliveryqvqTWcYewYpT30R3iFpuAuYpHbU26NkbICDrS4rPZ1MMeta } from "/var/www/2025-06-09_17_20/pages/cash-on-delivery.vue?macro=true";
import { default as happynewyear20248wJaRc4qsdNvDphHNxiw44Q8Yiy0hUegpBhSAqKRmtsMeta } from "/var/www/2025-06-09_17_20/pages/happynewyear2024.vue?macro=true";
import { default as ozon1Hw_45rSwg_45SZvrNGP2ZlSVvdJwglfOgU4_451qb26AMW8MMeta } from "/var/www/2025-06-09_17_20/pages/marketplace/ozon.vue?macro=true";
import { default as pay_45failAzhXLPQzlr5HHwc4TxeBqq_vw6YxAjy7dhkJj_45hbqOgMeta } from "/var/www/2025-06-09_17_20/pages/payment/pay-fail.vue?macro=true";
import { default as accountMEHF_45LYZvg8ovyrubrCiG90lwKwhRJy2Tj_45d2Z_45gj_kMeta } from "/var/www/2025-06-09_17_20/pages/personal/account.vue?macro=true";
import { default as prohibited_45goodsGi4Mia2TYu3WDTMU6TxrRse0q9SXqOr915EuOS34iQIMeta } from "/var/www/2025-06-09_17_20/pages/prohibited-goods.vue?macro=true";
import { default as directionJbwhBnuh3YdWY5Ss00APu9wSU0OaOVTxJFItEBh08iUMeta } from "/var/www/2025-06-09_17_20/pages/ui-kit/direction.vue?macro=true";
import { default as free_45group_45pickupZ_vQt6LJNOylfEv5flb3uV5iSbbIO20w7VjcB0Gf7TQMeta } from "/var/www/2025-06-09_17_20/pages/free-group-pickup.vue?macro=true";
import { default as free_45pickup_45cargoeNAFIlP6f2eaXSlgbfV2CG3pJ3fpwnnI8O2DIfRKuaQMeta } from "/var/www/2025-06-09_17_20/pages/free-pickup-cargo.vue?macro=true";
import { default as calculatorsj0alwGuhposS8l8DyWFK5kFAlZWxcVsT7Mvud_45sfRoMeta } from "/var/www/2025-06-09_17_20/pages/iframe/calculator.vue?macro=true";
import { default as merch_45for_45bonuseslb97lLy50C3LS3Aouf5GKAuQlnANQ_45tShEnvYQg56vIMeta } from "/var/www/2025-06-09_17_20/pages/merch-for-bonuses.vue?macro=true";
import { default as _91id_93OR5dn3zgzeZbAxfP8PE3cblwnKPa_45r4Vx_RltypOo7AMeta } from "/var/www/2025-06-09_17_20/pages/order/pay/qr/[id].vue?macro=true";
import { default as card_45infohQ_frKvRXnwECEyx87LzHRIs8pd_yi_45NhkuqQjGrssMMeta } from "/var/www/2025-06-09_17_20/pages/payment/card-info.vue?macro=true";
import { default as discounthGFwkZgsIsyOuRVN_4542u0vTvy6_45uBQVzWND7lMTwpTwMeta } from "/var/www/2025-06-09_17_20/pages/personal/discount.vue?macro=true";
import { default as hard_45boxRDNHlOQqcEoayeyOTR6b5Q78ad_X1imLJAbgtuLOncoMeta } from "/var/www/2025-06-09_17_20/pages/wrapping/hard-box.vue?macro=true";
import { default as forwarding_45receiptFhkyDsiye3Rxn0LEg8Or26OdGJ_458kRG0aAwdsJK4F0UMeta } from "/var/www/2025-06-09_17_20/pages/forwarding-receipt.vue?macro=true";
import { default as mailClient102019173Ui3629az7CSH8eLj_8shpmo48NmDZH1N9AGOQxvfz4Meta } from "/var/www/2025-06-09_17_20/pages/mailClient10201917.vue?macro=true";
import { default as mobile_45applicationUvg6hnTxHoI_Sya3rhA_45AHVJX1BwKsQNAojdHVUHDcYMeta } from "/var/www/2025-06-09_17_20/pages/mobile-application.vue?macro=true";
import { default as indexk9Ao0Toc4zpLvXUIl1PE384CKBZNdSZFqDjw8aNuH_45gMeta } from "/var/www/2025-06-09_17_20/pages/order/create/index.vue?macro=true";
import { default as boatqyVM0b8bxOnI_AwsX9Zq9pt71l6QUxFTPzCJ2eVFWDMMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/boat.vue?macro=true";
import { default as sofafnhcQpPySwL3sW4JwB2kz0iTF0hkggXQitdOnv_4555AgMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/sofa.vue?macro=true";
import { default as cardboardyMSJVffo_45KDAyB7yglFMn1DDRzZmaUFOIpTXI9aLG_IMeta } from "/var/www/2025-06-09_17_20/pages/wrapping/cardboard.vue?macro=true";
import { default as promocodes0thHMVTkC8SQCL8jrj6dRYmF6CdUxqP_45ZHOGdBwiIFkMeta } from "/var/www/2025-06-09_17_20/pages/personal/promocodes.vue?macro=true";
import { default as bench4ZlykXAJLW7Q_8WPJSxh5vH6vmUh6_45rGbnGmJ_4ORIgMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/bench.vue?macro=true";
import { default as books5U4n3crukLOtgdd2Ti6Rl8FRs3mvZjcMtYyCCw0kP98Meta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/books.vue?macro=true";
import { default as cable53Nrjas0rKjhC_45qmz3p5fDpC_45ydriXbtcAz37IzEHGkMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/cable.vue?macro=true";
import { default as chairbscXI8uJ9bHBkyR5YVd_UaKD7hygYpbx3bUwn61gm08Meta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/chair.vue?macro=true";
import { default as goodsQClFRwaGnKX0Ml51sjgSsUeFVINUavqepshd1kL4QUUMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/goods.vue?macro=true";
import { default as index0XFQMTOjkVDpYrLe3trtPbQiaVhSvbKl66hspVrGvw8Meta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/index.vue?macro=true";
import { default as metalfhkERQbr_45Wo5_45HHNgmCB6_45CX_457sC_V0fb_q91ObPQg4Meta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/metal.vue?macro=true";
import { default as pianoAmxoTSFXP6NVtSxkWDwbGxBiYiWS309XQphdGZBN_fIMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/piano.vue?macro=true";
import { default as pipesx_45y3kj1blYuU93xLT12hx5fkFkVaCrjBBljIqPVxRO0Meta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/pipes.vue?macro=true";
import { default as toolsXAH95nOvkMT5uV85CBfxcau4a9HwG0xcxHxda1AVq9QMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/tools.vue?macro=true";
import { default as pallet_45boxI4pH_QBWrXV3QPbPiNr5HdCqTRqoM4TbqjARIB8ESTwMeta } from "/var/www/2025-06-09_17_20/pages/wrapping/pallet-box.vue?macro=true";
import { default as _91tab_93qomWGPeXm_Pb_45D_45zburChPGzZsKn1HqX41HY3oq_qisMeta } from "/var/www/2025-06-09_17_20/pages/personal/bonus/[tab].vue?macro=true";
import { default as printSzOeoDxfY0YPY5bj9hpBDcpWUo0R3iWETojjKLYi2LQMeta } from "/var/www/2025-06-09_17_20/pages/personal/order/print.vue?macro=true";
import { default as dishesjxzQUpBbxyzLR0OwpaF1VRVhM4StTiiF_45hobKOzWgK0Meta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/dishes.vue?macro=true";
import { default as engineLxG1C5AL2Peb4YnQJjtekjwQEgsHl_Dm0aqEpDoQaT4Meta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/engine.vue?macro=true";
import { default as lumberAQ_45QQiG1NoE7AAyHaQC2UctAdEVO1c_O5oiqKeM9cXYMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/lumber.vue?macro=true";
import { default as wheelsnjtGpmc7dM1L4Efxc6wBQCrbG1H7vesNU0CGZpDqOwQMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/wheels.vue?macro=true";
import { default as bubble_45film_8D_45jCMBrpNA8NM8xY5Z0mJPSwCwPxhsJdG7Wq9NRVwMeta } from "/var/www/2025-06-09_17_20/pages/wrapping/bubble-film.vue?macro=true";
import { default as palletising6pOaBnxlvVadXFtATHlhT6lSPUhZ3LFulwSfp9w1hf8Meta } from "/var/www/2025-06-09_17_20/pages/wrapping/palletising.vue?macro=true";
import { default as fast_45delivery_45capitalOQ78wQ_45ijpfFy9JTMmOAFQE_45m0JVrf6ozVOBfCMPbFgMeta } from "/var/www/2025-06-09_17_20/pages/fast-delivery-capital.vue?macro=true";
import { default as _91guid_93aWL1pDeS1nTZPr2DrUKGJTt70Q6pUdpDYHV6IT_45QYC8Meta } from "/var/www/2025-06-09_17_20/pages/personal/order/[guid].vue?macro=true";
import { default as createJEiVmLYGx6UmeJS6_45cYAsCLT8CGSeUpglQXpY7cP0q8Meta } from "/var/www/2025-06-09_17_20/pages/personal/order/create.vue?macro=true";
import { default as barrelsc_vsSfymLTWiMZ92P0oKepySRoBNkO7kwWdJnoT8jbMMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/barrels.vue?macro=true";
import { default as clothesniqZqMBPCpxOPqd_P2u4i0LHZfAcuaMCsM4y7ImBLVIMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/clothes.vue?macro=true";
import { default as fragile_3ROIGJGbuJt7c7gZr5SXUmn_45XpLIjuc7CQ1Hc5Cs7YMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/fragile.vue?macro=true";
import { default as traileroX_45tHrblQ2GYjQchagp9vZc7shkIB4iUtuVJaM09O0YMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/trailer.vue?macro=true";
import { default as safe_45package40V8ucK_4518Dia5MES0DpAOy_456wLp6DAxXTA8y7gUfGYMeta } from "/var/www/2025-06-09_17_20/pages/wrapping/safe-package.vue?macro=true";
import { default as bepaid_45successozegePl1aaNTxbU8HKEs7qKATvhUq6uCNvlfOaUaLmwMeta } from "/var/www/2025-06-09_17_20/pages/payment/bepaid-success.vue?macro=true";
import { default as extra_45packageViKCINIuOKDDXlv786yF1Cf8gAo3Fx_45oDkSZlVxrNvsMeta } from "/var/www/2025-06-09_17_20/pages/wrapping/extra-package.vue?macro=true";
import { default as wildberriesbUGWN0DsFbiKePQ6fVrOV9q6GZq_cHQziXXBWK_45f9mMMeta } from "/var/www/2025-06-09_17_20/pages/marketplace/wildberries.vue?macro=true";
import { default as _91guid_937ypF56Elo1S_45_2_45yYjV4VGapq_458EXfZWzOyVvcvZPu0Meta } from "/var/www/2025-06-09_17_20/pages/order/administer/[guid].vue?macro=true";
import { default as furnitureX532wy8xQuq1RSMWNL9puqLJp89x1YaRa1XeZq4yTYYMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/furniture.vue?macro=true";
import { default as oversizedYxpQv4ezWm41XGJMA9RJFmjis_cptKjCaPc_45rO_45Jbm8Meta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/oversized.vue?macro=true";
import { default as quad_45bikeVHyueLnmNuuO4SRvdu_KYdTs3aKI4tEvjMFBEOnoCBUMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/quad-bike.vue?macro=true";
import { default as _91locations_93xBbym_310xfhAdbir0TJ5WztAFGz26EuKuHcNw_z__45oMeta } from "/var/www/2025-06-09_17_20/pages/order/create/[locations].vue?macro=true";
import { default as _91_46_46_46tab_93TooWn_45oHFrfraC9hVBBE_iUMREy5DsBJ_45ph3_45WwMT_oMeta } from "/var/www/2025-06-09_17_20/pages/personal/orders/[...tab].vue?macro=true";
import { default as auto_45partsKqktUwG_brPZ7KTnF2oSarUucj_45USPyJDIVswiquRmQMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/auto-parts.vue?macro=true";
import { default as newspapersCfbN2Ltd5P_P4uDPf0g9j_45Wpo1GTNhxDeB7qRDaEC6MMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/newspapers.vue?macro=true";
import { default as smallcargogEQ9GlAh6KpV0c0JVLCIRkBrymlBasOG8pH2yssmRdYMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/smallcargo.vue?macro=true";
import { default as snowmobileaJF8CveiXN3RGgf0Kf_45LIo3HxQsWJz8R4y07AEINl38Meta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/snowmobile.vue?macro=true";
import { default as indexENsJ61OdDZb79ZJE98U988W91akqUDLCyjG0_45UIOnpUMeta } from "/var/www/2025-06-09_17_20/pages/iframe/order/create/index.vue?macro=true";
import { default as yandex_45marketZDr67bL_45z0qKG3mBXlQe9zG3frX7ISG4shRql8JqDXYMeta } from "/var/www/2025-06-09_17_20/pages/marketplace/yandex-market.vue?macro=true";
import { default as templatesznZgy5Q5_AhTf9O_84OJG04tEoM7lFT_J6U6bfpuJxYMeta } from "/var/www/2025-06-09_17_20/pages/personal/orders/templates.vue?macro=true";
import { default as index21WVfKqhF5i56JMA6QC2NVlDOPuOS9_FgEEaxGpSGQoMeta } from "/var/www/2025-06-09_17_20/pages/personal/contractors/index.vue?macro=true";
import { default as refrigerator4xuJzUwJ4w6wGz7xqjKfZQBTKKVu7Hl1bKLxYdDbQhkMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/refrigerator.vue?macro=true";
import { default as _91guid_93W3kCOIRkzQUY_LCio26CbtiprmIj3mzuMHFDkS30eOAMeta } from "/var/www/2025-06-09_17_20/pages/personal/contractors/[guid].vue?macro=true";
import { default as indexP_Cd9YTeWxwHN25UcjaxW0iNirKgHSoIJYof_tuC9VAMeta } from "/var/www/2025-06-09_17_20/pages/personal/multi-pickup/index.vue?macro=true";
import { default as _91guid_93K_6geVON60SCbk79nWaW_XPIivxo5WfVbANpA5lDQRoMeta } from "/var/www/2025-06-09_17_20/pages/personal/multi-pickup/[guid].vue?macro=true";
import { default as consumer_45goodsxugQvFPQUYLEI0oW8VaaKrhT9XQFsSRpoD5__WtIsrwMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/consumer-goods.vue?macro=true";
import { default as indexbBxYzouBeKFbRBN2LbNsIRcwWp7Or_45qhm_6f1ePmfNQMeta } from "/var/www/2025-06-09_17_20/pages/personal/group-printing/index.vue?macro=true";
import { default as indexXpupFHLZv6IZNxjlZwnWwsOpV21kST3RF33QzloOi7IMeta } from "/var/www/2025-06-09_17_20/pages/personal/multi-delivery/index.vue?macro=true";
import { default as medical_45devicesnuDihsndob6gcdYpJ_YkljFjKtwvvwtCuD7OaEoI3ZEMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/medical-devices.vue?macro=true";
import { default as _91guid_93_b_45opbFcj9kWqOf_qmJK1v1iMBsUL8qyqer1eP0lXC0Meta } from "/var/www/2025-06-09_17_20/pages/iframe/order/administer/[guid].vue?macro=true";
import { default as _91guid_93izCZb9QwrtbDi342YqThyo9CQOLvgtlJEsznHeOgmM0Meta } from "/var/www/2025-06-09_17_20/pages/personal/multi-delivery/[guid].vue?macro=true";
import { default as _91_46_46_46id_93p_pvT6NUjCfGt4PfPOIrLElj6vYPHp_45I1oyE1TWj6BkMeta } from "/var/www/2025-06-09_17_20/pages/personal/order/template/[...id].vue?macro=true";
import { default as special_45equipment9lCVJUM3R5NFjA4wgks7rXQRAzRbUiBvur0AVwCV3fYMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/special-equipment.vue?macro=true";
import { default as building_45materialsrZ6CUqOt_45JpTuCvWNo5dacdItlb9Ckkw7rXiB2TuaXAMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/building-materials.vue?macro=true";
import { default as musical_45instrumentsSE0cP_lte1_h03K9S_45S7fmlo6Thp1O7XiiLT8PyYLEAMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/musical-instruments.vue?macro=true";
import { default as industrial_45equipmentB1Z8QYMHhLSe3eQkJemm7VhRcOoZyksXAL62_45xlfQnwMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/industrial-equipment.vue?macro=true";
import { default as motorcycletransportationa5e6KU7SXfFH8dXBR45yEUm6rCvMufUSMrozxK0K22AMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/motorcycletransportation.vue?macro=true";
import { default as _91locationFrom_93__91locationTo_93e_45Omhju4L6aUtxB4aEQ0r7lzUlS_aRs_wXU49jzMYcAMeta } from "/var/www/2025-06-09_17_20/pages/order/create/[locationFrom]_[locationTo].vue?macro=true";
import { default as personalitemstransportationazXcASRw8hfdi6xMFA6ZDumZn_NfeimAMAVZeLD6i3sMeta } from "/var/www/2025-06-09_17_20/pages/shippingtypes/personalitemstransportation.vue?macro=true";
export default [
  {
    name: "edo",
    path: "/edo",
    component: () => import("/var/www/2025-06-09_17_20/pages/edo.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/var/www/2025-06-09_17_20/pages/help.vue")
  },
  {
    name: "cargo",
    path: "/cargo",
    component: () => import("/var/www/2025-06-09_17_20/pages/cargo.vue")
  },
  {
    name: "china",
    path: "/china",
    component: () => import("/var/www/2025-06-09_17_20/pages/china.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/2025-06-09_17_20/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_93gxTN041b_45LmofYwJFFlKlvfl2iwujsiDFLmwN4rVZKsMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/[slug].vue")
  },
  {
    name: "belarus",
    path: "/belarus",
    component: () => import("/var/www/2025-06-09_17_20/pages/belarus.vue")
  },
  {
    name: "bonuses",
    path: "/bonuses",
    component: () => import("/var/www/2025-06-09_17_20/pages/bonuses.vue")
  },
  {
    name: "dev-api",
    path: "/dev/api",
    component: () => import("/var/www/2025-06-09_17_20/pages/dev/api.vue")
  },
  {
    name: "dev-cms",
    path: "/dev/cms",
    component: () => import("/var/www/2025-06-09_17_20/pages/dev/cms.vue")
  },
  {
    name: "konkurs",
    path: "/konkurs",
    meta: konkursuTVN5Px3Nj9_ejCRbSa6P5MIqPtN2_iCOyTC5GjPBLgMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/konkurs.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/var/www/2025-06-09_17_20/pages/success.vue")
  },
  {
    name: "tariffs",
    path: "/tariffs",
    component: () => import("/var/www/2025-06-09_17_20/pages/tariffs.vue")
  },
  {
    name: "vacancy",
    path: "/vacancy",
    component: () => import("/var/www/2025-06-09_17_20/pages/vacancy.vue")
  },
  {
    name: "contacts",
    path: "/:tag(address|contacts)/:location?",
    meta: contactsKAI1qbkHRYReaMSRcsmkObSeytRy0yJa0GATn_I64ugMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/contacts.vue")
  },
  {
    name: "giveaway",
    path: "/giveaway",
    component: () => import("/var/www/2025-06-09_17_20/pages/giveaway.vue")
  },
  {
    name: "guide-lk",
    path: "/guide-lk",
    component: () => import("/var/www/2025-06-09_17_20/pages/guide-lk.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/var/www/2025-06-09_17_20/pages/services.vue")
  },
  {
    name: "telegram",
    path: "/telegram",
    component: () => import("/var/www/2025-06-09_17_20/pages/telegram.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/var/www/2025-06-09_17_20/pages/documents.vue")
  },
  {
    name: "franchise",
    path: "/franchise",
    component: () => import("/var/www/2025-06-09_17_20/pages/franchise.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    component: () => import("/var/www/2025-06-09_17_20/pages/insurance.vue")
  },
  {
    name: "kirghizia",
    path: "/kirghizia",
    component: () => import("/var/www/2025-06-09_17_20/pages/kirghizia.vue")
  },
  {
    name: "mapScheme",
    path: "/mapScheme",
    meta: mapSchemeeuuH0MlEB0fN3MxVhnBTK1qgDAxKTdOmN1rFiiwg14sMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/mapScheme.vue")
  },
  {
    name: "news-id",
    path: "/:tag(news|actions)/:id",
    meta: _91id_93nTW7bvpipa6_45l6zbwDekUcTLX7bDSW3vgF35okipk4AMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/news/[id].vue")
  },
  {
    name: "return-sd",
    path: "/return-sd",
    component: () => import("/var/www/2025-06-09_17_20/pages/return-sd.vue")
  },
  {
    name: "smsClient",
    path: "/smsClient",
    component: () => import("/var/www/2025-06-09_17_20/pages/smsClient.vue")
  },
  {
    name: "terminals",
    path: "/terminals",
    component: () => import("/var/www/2025-06-09_17_20/pages/terminals.vue")
  },
  {
    name: "dev-iframe",
    path: "/dev/iframe",
    component: () => import("/var/www/2025-06-09_17_20/pages/dev/iframe.vue")
  },
  {
    name: "directions",
    path: "/directions",
    component: () => import("/var/www/2025-06-09_17_20/pages/directions.vue")
  },
  {
    name: "kazakhstan",
    path: "/kazakhstan",
    component: () => import("/var/www/2025-06-09_17_20/pages/kazakhstan.vue")
  },
  {
    name: "news",
    path: "/:tag(news|actions)",
    meta: indexpIDvkyFQ_45UNnyocl9BHAR_z1rfizRNqxgBCHC0AJBFwMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/news/index.vue")
  },
  {
    name: "ui-kit-svg",
    path: "/ui-kit/svg",
    component: () => import("/var/www/2025-06-09_17_20/pages/ui-kit/svg.vue")
  },
  {
    name: "vzpay-fail",
    path: "/vzpay-fail",
    component: () => import("/var/www/2025-06-09_17_20/pages/vzpay-fail.vue")
  },
  {
    name: "constructor",
    path: "/constructor",
    meta: constructorYrGu4RsDdUKp6oMWRw_45y1N4eROrryjZfdzxj4H8DCCoMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/constructor.vue")
  },
  {
    name: "gifts",
    path: "/gifts",
    meta: indexSz_45ycf880bbb1BBDRrPV6OdEHioUMWFNrEX0AbtX_UAMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/gifts/index.vue")
  },
  {
    name: "information",
    path: "/information",
    component: () => import("/var/www/2025-06-09_17_20/pages/information.vue")
  },
  {
    name: "order-light",
    path: "/order/light",
    component: () => import("/var/www/2025-06-09_17_20/pages/order/light.vue")
  },
  {
    name: "claim-filing",
    path: "/claim-filing",
    component: () => import("/var/www/2025-06-09_17_20/pages/claim-filing.vue")
  },
  {
    name: "gifts-type",
    path: "/gift/:type(m|o)",
    meta: _91type_933ra2SlhHKYupZlImm5zAw6OTDhzwbxcU2hR7_45ZzVrDMMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/gifts/[type].vue")
  },
  {
    name: "marketplaces",
    path: "/marketplaces",
    component: () => import("/var/www/2025-06-09_17_20/pages/marketplaces.vue")
  },
  {
    name: "networkshops",
    path: "/networkshops",
    component: () => import("/var/www/2025-06-09_17_20/pages/networkshops.vue")
  },
  {
    name: "online-store",
    path: "/online-store",
    component: () => import("/var/www/2025-06-09_17_20/pages/online-store.vue")
  },
  {
    name: "order-manage",
    path: "/order/manage",
    component: () => import("/var/www/2025-06-09_17_20/pages/order/manage.vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/var/www/2025-06-09_17_20/pages/registration.vue")
  },
  {
    name: "run-schedule",
    path: "/run-schedule",
    component: () => import("/var/www/2025-06-09_17_20/pages/run-schedule.vue")
  },
  {
    name: "safe-custody",
    path: "/safe-custody",
    component: () => import("/var/www/2025-06-09_17_20/pages/safe-custody.vue")
  },
  {
    name: "ui-kit-image",
    path: "/ui-kit/image",
    component: () => import("/var/www/2025-06-09_17_20/pages/ui-kit/image.vue")
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    component: () => import("/var/www/2025-06-09_17_20/pages/ui-kit/index.vue")
  },
  {
    name: "wrapping-bag",
    path: "/wrapping/bag",
    component: () => import("/var/www/2025-06-09_17_20/pages/wrapping/bag.vue")
  },
  {
    name: "wrapping-box",
    path: "/wrapping/box",
    component: () => import("/var/www/2025-06-09_17_20/pages/wrapping/box.vue")
  },
  {
    name: "cargo-loading",
    path: "/cargo-loading",
    component: () => import("/var/www/2025-06-09_17_20/pages/cargo-loading.vue")
  },
  {
    name: "happybirthday",
    path: "/happybirthday",
    meta: happybirthdayEV0gy9GavUUqsHk6F9mCZdIeKqMFPOh5xkC5eD2taucMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/happybirthday.vue")
  },
  {
    name: "iframe-manage",
    path: "/iframe/manage",
    meta: manageneaTuz1CqErIwgT2ciUWb2SvWHKcjDwgry19H3jnANoMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/iframe/manage.vue")
  },
  {
    name: "personal-auth",
    path: "/personal/auth",
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/auth.vue")
  },
  {
    name: "ui-kit-public",
    path: "/ui-kit/public",
    component: () => import("/var/www/2025-06-09_17_20/pages/ui-kit/public.vue")
  },
  {
    name: "already-answer",
    path: "/already-answer",
    component: () => import("/var/www/2025-06-09_17_20/pages/already-answer.vue")
  },
  {
    name: "iframe-tariffs",
    path: "/iframe/tariffs",
    meta: tariffshJLOaLrv7Bi7TFxBKTKPlpYWzJTy_Y5oFORsqbvqQkwMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/iframe/tariffs.vue")
  },
  {
    name: "order-pay-id",
    path: "/order/pay/:id()",
    component: () => import("/var/www/2025-06-09_17_20/pages/order/pay/[id].vue")
  },
  {
    name: "personal",
    path: "/personal",
    meta: indexRvE1pXrdGZZYAzUcGGVR3CRKF_45romhywBWB84eqRHr8Meta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/var/www/2025-06-09_17_20/pages/privacy-policy.vue")
  },
  {
    name: "welcome-hash",
    path: "/welcome/:hash()",
    component: () => import("/var/www/2025-06-09_17_20/pages/welcome/[hash].vue")
  },
  {
    name: "wrapping",
    path: "/wrapping",
    component: () => import("/var/www/2025-06-09_17_20/pages/wrapping/index.vue")
  },
  {
    name: "delivery-russia",
    path: "/delivery-russia",
    component: () => import("/var/www/2025-06-09_17_20/pages/delivery-russia.vue")
  },
  {
    name: "payment-methods",
    path: "/payment-methods",
    component: () => import("/var/www/2025-06-09_17_20/pages/payment-methods.vue")
  },
  {
    name: "payment-qr-info",
    path: "/payment/qr-info",
    component: () => import("/var/www/2025-06-09_17_20/pages/payment/qr-info.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/var/www/2025-06-09_17_20/pages/payment/success.vue")
  },
  {
    name: "personal-import",
    path: "/personal/import",
    meta: importTyOaM_45NgqooTYkprjsm6d2t3D5adAKIXgxJ0Dni1kHIMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/import.vue")
  },
  {
    name: "personal-logout",
    path: "/personal/logout",
    meta: logout8WFmjF89qSSQZfozrtq3mz4mnbxZkBPWiNAt2alFTngMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/logout.vue")
  },
  {
    name: "address-delivery",
    path: "/address-delivery",
    component: () => import("/var/www/2025-06-09_17_20/pages/address-delivery.vue")
  },
  {
    name: "cash-on-delivery",
    path: "/cash-on-delivery",
    component: () => import("/var/www/2025-06-09_17_20/pages/cash-on-delivery.vue")
  },
  {
    name: "happynewyear2024",
    path: "/happynewyear2024",
    meta: happynewyear20248wJaRc4qsdNvDphHNxiw44Q8Yiy0hUegpBhSAqKRmtsMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/happynewyear2024.vue")
  },
  {
    name: "marketplace-ozon",
    path: "/ozon",
    meta: ozon1Hw_45rSwg_45SZvrNGP2ZlSVvdJwglfOgU4_451qb26AMW8MMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/marketplace/ozon.vue")
  },
  {
    name: "payment-pay-fail",
    path: "/payment/pay-fail",
    component: () => import("/var/www/2025-06-09_17_20/pages/payment/pay-fail.vue")
  },
  {
    name: "personal-account",
    path: "/personal/account",
    meta: accountMEHF_45LYZvg8ovyrubrCiG90lwKwhRJy2Tj_45d2Z_45gj_kMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/account.vue")
  },
  {
    name: "prohibited-goods",
    path: "/prohibited-goods",
    component: () => import("/var/www/2025-06-09_17_20/pages/prohibited-goods.vue")
  },
  {
    name: "ui-kit-direction",
    path: "/ui-kit/direction",
    component: () => import("/var/www/2025-06-09_17_20/pages/ui-kit/direction.vue")
  },
  {
    name: "free-group-pickup",
    path: "/free-group-pickup",
    component: () => import("/var/www/2025-06-09_17_20/pages/free-group-pickup.vue")
  },
  {
    name: "free-pickup-cargo",
    path: "/free-pickup-cargo",
    component: () => import("/var/www/2025-06-09_17_20/pages/free-pickup-cargo.vue")
  },
  {
    name: "iframe-calculator",
    path: "/iframe/calculator",
    meta: calculatorsj0alwGuhposS8l8DyWFK5kFAlZWxcVsT7Mvud_45sfRoMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/iframe/calculator.vue")
  },
  {
    name: "merch-for-bonuses",
    path: "/merch-for-bonuses",
    component: () => import("/var/www/2025-06-09_17_20/pages/merch-for-bonuses.vue")
  },
  {
    name: "order-pay-qr-id",
    path: "/order/pay/qr/:id()",
    component: () => import("/var/www/2025-06-09_17_20/pages/order/pay/qr/[id].vue")
  },
  {
    name: "payment-card-info",
    path: "/payment/card-info",
    component: () => import("/var/www/2025-06-09_17_20/pages/payment/card-info.vue")
  },
  {
    name: "personal-discount",
    path: "/personal/discount",
    meta: discounthGFwkZgsIsyOuRVN_4542u0vTvy6_45uBQVzWND7lMTwpTwMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/discount.vue")
  },
  {
    name: "wrapping-hard-box",
    path: "/wrapping/hard-box",
    component: () => import("/var/www/2025-06-09_17_20/pages/wrapping/hard-box.vue")
  },
  {
    name: "forwarding-receipt",
    path: "/forwarding-receipt",
    component: () => import("/var/www/2025-06-09_17_20/pages/forwarding-receipt.vue")
  },
  {
    name: "mailClient10201917",
    path: "/mailClient10201917",
    meta: mailClient102019173Ui3629az7CSH8eLj_8shpmo48NmDZH1N9AGOQxvfz4Meta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/mailClient10201917.vue")
  },
  {
    name: "mobile-application",
    path: "/mobile-application",
    component: () => import("/var/www/2025-06-09_17_20/pages/mobile-application.vue")
  },
  {
    name: "order-create",
    path: "/order/create",
    meta: indexk9Ao0Toc4zpLvXUIl1PE384CKBZNdSZFqDjw8aNuH_45gMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/order/create/index.vue")
  },
  {
    name: "shippingtypes-boat",
    path: "/shippingtypes/boat",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/boat.vue")
  },
  {
    name: "shippingtypes-sofa",
    path: "/shippingtypes/sofa",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/sofa.vue")
  },
  {
    name: "wrapping-cardboard",
    path: "/wrapping/cardboard",
    component: () => import("/var/www/2025-06-09_17_20/pages/wrapping/cardboard.vue")
  },
  {
    name: "personal-promocodes",
    path: "/personal/promocodes",
    meta: promocodes0thHMVTkC8SQCL8jrj6dRYmF6CdUxqP_45ZHOGdBwiIFkMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/promocodes.vue")
  },
  {
    name: "shippingtypes-bench",
    path: "/shippingtypes/bench",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/bench.vue")
  },
  {
    name: "shippingtypes-books",
    path: "/shippingtypes/books",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/books.vue")
  },
  {
    name: "shippingtypes-cable",
    path: "/shippingtypes/cable",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/cable.vue")
  },
  {
    name: "shippingtypes-chair",
    path: "/shippingtypes/chair",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/chair.vue")
  },
  {
    name: "shippingtypes-goods",
    path: "/shippingtypes/goods",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/goods.vue")
  },
  {
    name: "shippingtypes",
    path: "/shippingtypes",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/index.vue")
  },
  {
    name: "shippingtypes-metal",
    path: "/shippingtypes/metal",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/metal.vue")
  },
  {
    name: "shippingtypes-piano",
    path: "/shippingtypes/piano",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/piano.vue")
  },
  {
    name: "shippingtypes-pipes",
    path: "/shippingtypes/pipes",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/pipes.vue")
  },
  {
    name: "shippingtypes-tools",
    path: "/shippingtypes/tools",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/tools.vue")
  },
  {
    name: "wrapping-pallet-box",
    path: "/wrapping/pallet-box",
    component: () => import("/var/www/2025-06-09_17_20/pages/wrapping/pallet-box.vue")
  },
  {
    name: "personal-bonus-tab",
    path: "/personal/bonus/:tab()",
    meta: _91tab_93qomWGPeXm_Pb_45D_45zburChPGzZsKn1HqX41HY3oq_qisMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/bonus/[tab].vue")
  },
  {
    name: "personal-order-print",
    path: "/personal/order/print",
    meta: printSzOeoDxfY0YPY5bj9hpBDcpWUo0R3iWETojjKLYi2LQMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/order/print.vue")
  },
  {
    name: "shippingtypes-dishes",
    path: "/shippingtypes/dishes",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/dishes.vue")
  },
  {
    name: "shippingtypes-engine",
    path: "/shippingtypes/engine",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/engine.vue")
  },
  {
    name: "shippingtypes-lumber",
    path: "/shippingtypes/lumber",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/lumber.vue")
  },
  {
    name: "shippingtypes-wheels",
    path: "/shippingtypes/wheels",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/wheels.vue")
  },
  {
    name: "wrapping-bubble-film",
    path: "/wrapping/bubble-film",
    component: () => import("/var/www/2025-06-09_17_20/pages/wrapping/bubble-film.vue")
  },
  {
    name: "wrapping-palletising",
    path: "/wrapping/palletising",
    component: () => import("/var/www/2025-06-09_17_20/pages/wrapping/palletising.vue")
  },
  {
    name: "fast-delivery-capital",
    path: "/fast-delivery-capital",
    component: () => import("/var/www/2025-06-09_17_20/pages/fast-delivery-capital.vue")
  },
  {
    name: "personal-order-guid",
    path: "/personal/order/:tag(pay)?/:guid",
    meta: _91guid_93aWL1pDeS1nTZPr2DrUKGJTt70Q6pUdpDYHV6IT_45QYC8Meta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/order/[guid].vue")
  },
  {
    name: "personal-order-create",
    path: "/personal/order/create",
    meta: createJEiVmLYGx6UmeJS6_45cYAsCLT8CGSeUpglQXpY7cP0q8Meta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/order/create.vue")
  },
  {
    name: "shippingtypes-barrels",
    path: "/shippingtypes/barrels",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/barrels.vue")
  },
  {
    name: "shippingtypes-clothes",
    path: "/shippingtypes/clothes",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/clothes.vue")
  },
  {
    name: "shippingtypes-fragile",
    path: "/shippingtypes/fragile",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/fragile.vue")
  },
  {
    name: "shippingtypes-trailer",
    path: "/shippingtypes/trailer",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/trailer.vue")
  },
  {
    name: "wrapping-safe-package",
    path: "/wrapping/safe-package",
    component: () => import("/var/www/2025-06-09_17_20/pages/wrapping/safe-package.vue")
  },
  {
    name: "payment-bepaid-success",
    path: "/payment/bepaid-success",
    component: () => import("/var/www/2025-06-09_17_20/pages/payment/bepaid-success.vue")
  },
  {
    name: "wrapping-extra-package",
    path: "/wrapping/extra-package",
    component: () => import("/var/www/2025-06-09_17_20/pages/wrapping/extra-package.vue")
  },
  {
    name: "marketplace-wildberries",
    path: "/wildberries",
    meta: wildberriesbUGWN0DsFbiKePQ6fVrOV9q6GZq_cHQziXXBWK_45f9mMMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/marketplace/wildberries.vue")
  },
  {
    name: "order-administer-guid",
    path: "/order/administer/:guid()",
    component: () => import("/var/www/2025-06-09_17_20/pages/order/administer/[guid].vue")
  },
  {
    name: "shippingtypes-furniture",
    path: "/shippingtypes/furniture",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/furniture.vue")
  },
  {
    name: "shippingtypes-oversized",
    path: "/shippingtypes/oversized",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/oversized.vue")
  },
  {
    name: "shippingtypes-quad-bike",
    path: "/shippingtypes/quad-bike",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/quad-bike.vue")
  },
  {
    name: "order-create-locations",
    path: "/order/create/:locations()",
    component: () => import("/var/www/2025-06-09_17_20/pages/order/create/[locations].vue")
  },
  {
    name: "personal-orders-tab",
    path: "/personal/orders/:tab(.*)*",
    meta: _91_46_46_46tab_93TooWn_45oHFrfraC9hVBBE_iUMREy5DsBJ_45ph3_45WwMT_oMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/orders/[...tab].vue")
  },
  {
    name: "shippingtypes-auto-parts",
    path: "/shippingtypes/auto-parts",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/auto-parts.vue")
  },
  {
    name: "shippingtypes-newspapers",
    path: "/shippingtypes/newspapers",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/newspapers.vue")
  },
  {
    name: "shippingtypes-smallcargo",
    path: "/shippingtypes/smallcargo",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/smallcargo.vue")
  },
  {
    name: "shippingtypes-snowmobile",
    path: "/shippingtypes/snowmobile",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/snowmobile.vue")
  },
  {
    name: "iframe-order-create",
    path: "/iframe/order/create",
    meta: indexENsJ61OdDZb79ZJE98U988W91akqUDLCyjG0_45UIOnpUMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/iframe/order/create/index.vue")
  },
  {
    name: "marketplace-yandex-market",
    path: "/yandex-market",
    meta: yandex_45marketZDr67bL_45z0qKG3mBXlQe9zG3frX7ISG4shRql8JqDXYMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/marketplace/yandex-market.vue")
  },
  {
    name: "personal-orders-templates",
    path: "/personal/orders/templates",
    meta: templatesznZgy5Q5_AhTf9O_84OJG04tEoM7lFT_J6U6bfpuJxYMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/orders/templates.vue")
  },
  {
    name: "personal-contractors",
    path: "/personal/contractors",
    meta: index21WVfKqhF5i56JMA6QC2NVlDOPuOS9_FgEEaxGpSGQoMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/contractors/index.vue")
  },
  {
    name: "shippingtypes-refrigerator",
    path: "/shippingtypes/refrigerator",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/refrigerator.vue")
  },
  {
    name: "personal-contractors-guid",
    path: "/personal/contractors/:guid()",
    meta: _91guid_93W3kCOIRkzQUY_LCio26CbtiprmIj3mzuMHFDkS30eOAMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/contractors/[guid].vue")
  },
  {
    name: "personal-multi-pickup",
    path: "/personal/multi-pickup",
    meta: indexP_Cd9YTeWxwHN25UcjaxW0iNirKgHSoIJYof_tuC9VAMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/multi-pickup/index.vue")
  },
  {
    name: "personal-multi-pickup-guid",
    path: "/personal/multi-pickup/:guid",
    meta: _91guid_93K_6geVON60SCbk79nWaW_XPIivxo5WfVbANpA5lDQRoMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/multi-pickup/[guid].vue")
  },
  {
    name: "shippingtypes-consumer-goods",
    path: "/shippingtypes/consumer-goods",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/consumer-goods.vue")
  },
  {
    name: "personal-group-printing",
    path: "/personal/group-printing",
    meta: indexbBxYzouBeKFbRBN2LbNsIRcwWp7Or_45qhm_6f1ePmfNQMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/group-printing/index.vue")
  },
  {
    name: "personal-multi-delivery",
    path: "/personal/multi-delivery",
    meta: indexXpupFHLZv6IZNxjlZwnWwsOpV21kST3RF33QzloOi7IMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/multi-delivery/index.vue")
  },
  {
    name: "shippingtypes-medical-devices",
    path: "/shippingtypes/medical-devices",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/medical-devices.vue")
  },
  {
    name: "iframe-order-administer-guid",
    path: "/iframe/order/administer/:guid()",
    meta: _91guid_93_b_45opbFcj9kWqOf_qmJK1v1iMBsUL8qyqer1eP0lXC0Meta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/iframe/order/administer/[guid].vue")
  },
  {
    name: "personal-multi-delivery-guid",
    path: "/personal/multi-delivery/:guid",
    meta: _91guid_93izCZb9QwrtbDi342YqThyo9CQOLvgtlJEsznHeOgmM0Meta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/multi-delivery/[guid].vue")
  },
  {
    name: "personal-order-template-id",
    path: "/personal/order/template/:id(.*)*",
    meta: _91_46_46_46id_93p_pvT6NUjCfGt4PfPOIrLElj6vYPHp_45I1oyE1TWj6BkMeta || {},
    component: () => import("/var/www/2025-06-09_17_20/pages/personal/order/template/[...id].vue")
  },
  {
    name: "shippingtypes-special-equipment",
    path: "/shippingtypes/special-equipment",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/special-equipment.vue")
  },
  {
    name: "shippingtypes-building-materials",
    path: "/shippingtypes/building-materials",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/building-materials.vue")
  },
  {
    name: "shippingtypes-musical-instruments",
    path: "/shippingtypes/musical-instruments",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/musical-instruments.vue")
  },
  {
    name: "shippingtypes-industrial-equipment",
    path: "/shippingtypes/industrial-equipment",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/industrial-equipment.vue")
  },
  {
    name: "shippingtypes-motorcycletransportation",
    path: "/shippingtypes/motorcycletransportation",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/motorcycletransportation.vue")
  },
  {
    name: "order-create-locationFrom_locationTo",
    path: "/order/create/:locationFrom()_:locationTo()",
    component: () => import("/var/www/2025-06-09_17_20/pages/order/create/[locationFrom]_[locationTo].vue")
  },
  {
    name: "shippingtypes-personalitemstransportation",
    path: "/shippingtypes/personalitemstransportation",
    component: () => import("/var/www/2025-06-09_17_20/pages/shippingtypes/personalitemstransportation.vue")
  }
]